import React, { useEffect } from "react";
import { DataTable } from "../../Components/DataTable";
import { recentRvColumns } from "./tableConfig";
import { useRvs } from "../../hooks/useRv";


export const RecentRvsTab: React.FC = () => {
  const { monthRvs = [], isMonthLoading, fetchByMonth } = useRvs();

  useEffect(() => {
    const now = new Date();
    fetchByMonth(now.getFullYear(), now.getMonth() + 1);
  }, [fetchByMonth]);

  return (
    <section className="mt-10 bg-white p-6 rounded-xl shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold capitalize">Πρόσφατα Ραντεβού</h2>
      </div>
      <DataTable columns={recentRvColumns} data={monthRvs} loading={isMonthLoading} />
    </section>
  );
};